import React from "react";
import { isMobile } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import getOrganizedData from "./organizeData";

const PieColors = ["#66bb6a", "#ef5350", "#757575"];

/**
 * Card containing all others indicators..
 */
export default function ImportantIndicatorsCard({
  movingAverageData,
  extraData,
  report,
}) {
  if (!movingAverageData && !extraData) {
    return skeletonLoading();
  }

  let data = {
    movingAverageData: movingAverageData,
    newsData: extraData.news,
    averagePrice: extraData.averagePrice,
  };

  //Get data organized to render in this component
  const organizedData = getOrganizedData(data, report);

  if (organizedData) {
    const generatedIndicators = organizedData.indicators;
    const chartData = organizedData.chartData;

    const RADIAN = Math.PI / 180;
    const percentageLabel = ({
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      percent,
      index,
    }) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      return (
        <text
          x={x}
          y={y}
          fill="var(--text-6)"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
        >
          {chartData[index].value > 0 && `${(percent * 100).toFixed(0)}%`}
        </text>
      );
    };

    return (
      <div
        className="card card-dashboard-thirteen animated fadeInDown"
        style={{ width: "100%" }}
        id={!isMobile ? "analysis-step-6" : ""}
      >
        <h4>Avaliações importantes</h4>
        <p className="az-content-text">
          Confira outras avaliações importantes antes da sua tomada de decisão.
        </p>
        <div className="row mg-t-20 mg-b-20">
          <div className="col-lg-3">
            <div style={{ width: "100%", height: 170 }}>
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    data={chartData}
                    innerRadius={60}
                    outerRadius={80}
                    labelLine={false}
                    label={percentageLabel}
                    isAnimationActive={true}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {chartData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={PieColors[index % PieColors.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="col-lg-9 mg-t-40 mg-lg-t-0">
            <div className="row">
              {generatedIndicators.map((item, i) => {
                return (
                  <div
                    className={
                      isMobile
                        ? "col-md-6 col-sm-6 mg-t-15"
                        : i < 2
                        ? "col-md-6 col-sm-6 mg-t-20-OnlyMobile"
                        : "col-md-6 col-sm-6 mg-t-20"
                    }
                    key={i}
                    id={isMobile && i === 1 ? "analysis-step-6" : ""}
                  >
                    <div className="media">
                      <div className="media-icon" style={{ color: item.color }}>
                        {item.icon}
                      </div>
                      <div className="media-body">
                        <h6>{item.title}</h6>
                        <label>{item.subtitle}</label>
                      </div>
                    </div>

                    <span>{item.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
}

export const ImportantIndicatorsCardMemo = React.memo(ImportantIndicatorsCard);

const skeletonLoading = () => {
  return (
    <div className="card card-dashboard-thirteen" style={{ width: "100%" }}>
      <h4>Avaliações importantes</h4>
      <p className="az-content-text">
        Confira outras avaliações importantes antes da sua tomada de decisão.
      </p>
      <div className="pd-40">
        <Skeleton count={8} style={{ marginTop: 10 }} />
      </div>
    </div>
  );
};
